import Spinner from 'react-bootstrap/Spinner';
import { useSelector } from 'react-redux';
import { CountryCode } from '@domains/country';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { useDocumentsHistory } from '../../hooks/useDocumentsHistory';
import { HistoryCardCO, HistoryCardMX } from './components';
import {
  DocumentHistoryItemCO,
  DocumentHistoryItemMX,
} from '@domains/documents-review/interfaces/interfaces';

export const DocumentsHistoryList = () => {
  const { data: history = [], isLoading, error, nid } = useDocumentsHistory();
  const country = useSelector(getCountry) as CountryCode;

  if (!nid) return null;

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-4" data-testid="loading">
        <Spinner animation="border" variant="secondary" />
      </div>
    );
  }

  if (error) {
    return <div data-testid="error">Error al cargar historial</div>;
  }

  const historyToShow = history.slice(1);

  if (country === CountryCode.MX) {
    return (
      <div className="d-flex flex-column gap-2" data-testid="history-list">
        {historyToShow.map((item, index) => (
          <HistoryCardMX
            key={item.id}
            item={item as DocumentHistoryItemMX}
            index={index}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="d-flex flex-column gap-2" data-testid="history-list">
      {historyToShow.map((item, index) => (
        <HistoryCardCO
          key={item.id}
          item={item as DocumentHistoryItemCO}
          index={index}
        />
      ))}
    </div>
  );
};
